import { isNullish } from '@nx/stdlib';

const base64Pattern = /[A-Za-z0-9+/]+={0,2}/;
const validGaciPattern = /^[0-9]+\.[0-9]+$/;

export const extractGaClientId = (gl: string) => {
  const glKeyValArr = gl.split('*');
  const gaKeyIndex = glKeyValArr.findIndex((ele) => ele === '_ga');
  if (gaKeyIndex === -1) {
    return null;
  }

  const gaValIndex = gaKeyIndex + 1;
  const gaVal = glKeyValArr[gaValIndex];
  if (isNullish(gaVal)) {
    return null;
  }

  const base64Matches = gaVal.match(base64Pattern);
  if (isNullish(base64Matches) || base64Matches.length === 0) {
    return null;
  }

  const [gaValueStripped] = base64Matches;
  try {
    const decodedGaVal = atob(gaValueStripped);
    if (validGaciPattern.test(decodedGaVal)) {
      return decodedGaVal;
    }
  } catch {
    /* empty */
  }

  return null;
};

export const clearGlQueryParam = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('_gl');
  window.history.replaceState({}, '', url.href);
};
